<template>
  <v-content>
    <AppBar title="Registration utförd" />
    <v-container>
      <v-row no-gutters>
        <v-col>
          <v-card>
            <v-card-text>
              <div class="d-flex justify-center">
                <v-icon size="56" class="mb-4 primary--text">
                  mdi-check-circle-outline
                </v-icon>
              </div>
              <p>
                Din rapportering av bemanningsavvikelse på tåg
                <strong>{{ registration.train_number }}</strong
                >, <strong>{{ registrationDate }}</strong> är nu registrerad!
              </p>

              <p>Tack för hjälpen!</p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import AppBar from '@/components/AppBar.vue'
import { format } from 'date-fns'
import { get } from 'vuex-pathify'

export default {
  name: 'StaffDeviationRegistrationCompleted',

  components: {
    AppBar
  },

  computed: {
    registration: get('registration/data'),

    registrationDate() {
      return format(new Date(this.registration.created), 'yyyy-MM-dd')
    }
  }
}
</script>
